// role = 2 = public
export default function () {
  return {
    collection: 'directus_permissions',
    data: [
      {
        collection: 'directus_users',
        role: 2,
        read: 'full'
      },

      {
        collection: 'directus_files',
        role: 2,
        read: 'full'
      },

      {
        collection: 'site_config',
        role: 2,
        read: 'full'
      },

      {
        collection: 'member_seating_status',
        role: 2,
        read: 'full'
      }
    ]
  }
}
